import { Checkbox, Typography, WithInfoIcon } from 'seagull';
import styles from "./SignatoryCheckbox.module.scss";
import React from 'react';
const SignatoryCheckbox = _ref => {
  let {
    info,
    value,
    onChange,
    disabled = false,
    checkboxTestid = 'required-sign',
    infoTestid = 'required-sign-info'
  } = _ref;
  return /*#__PURE__*/React.createElement(WithInfoIcon, {
    infoTestId: infoTestid,
    info: info,
    className: styles.signatoryCheckbox
  }, /*#__PURE__*/React.createElement(Checkbox, {
    "data-testid": checkboxTestid,
    onChange: onChange,
    checked: value,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Typography, {
    noWrap: true
  }, "Required to sign")));
};
export default SignatoryCheckbox;